module.exports = __webpack_public_path__ + "img/color-down-icon.be435737.svg";